// extracted by mini-css-extract-plugin
module.exports = {"members":"styles_members__9r3UA","member":"styles_member__SvB2J","photo":"styles_photo__2QNgk","link":"styles_link__2qG9s"};